import { render } from "./AddVocabulary.vue?vue&type=template&id=86958108&scoped=true&ts=true"
import script from "./AddVocabulary.vue?vue&type=script&lang=ts"
export * from "./AddVocabulary.vue?vue&type=script&lang=ts"

import "./AddVocabulary.vue?vue&type=style&index=0&id=86958108&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86958108"]])

export default __exports__